import request from '@/utils/request'
import qs from 'qs'

/**
 * 根据用户名和密码登录
 * @param query
 */
export function getByUsername(username, password) {
	return request({
		url: '/api/a/authc',
		method: 'post',
		data: qs.stringify({ username: username, password: password })
	})
}
/**
 * 手机验证码登录
 * @param query
 */
export function mobileLogin(phone, code) {
	return request({
		url: '/api/login/mobile',
		method: 'post',
		data: qs.stringify({ phone: phone, captcha: code })
	})
}

/**
 * 修改手机号码
 * @param query
 */
export function mobileUpdate(userId,phone,companyId, code) {
	return request({
		url: `/api/update/mobile/${userId}/${companyId}`,
		method: 'post',
		data: qs.stringify({ phone: phone, captcha: code })
	})
}

/**
 * 修改邮箱
 * @param query
 */
export function emailUpdate(userId,email,companyId, code) {
	return request({
		url: `/api/update/email/${userId}/${companyId}`,
		method: 'post',
		data: qs.stringify({ email: email, captcha: code })
	})
}
/**
 * 获取验证码
 * @param query
 */
export function fetchVerify(phone, type) {
	return request({
		url: '/api/fetch/verify',
		method: 'post',
		data: qs.stringify({ phone: phone, type: type })
	})
}

/**
 * 获取邮箱验证码
 * @param query
 */
export function emailVerify(email) {
	return request({
		url: '/api/email',
		method: 'post',
		data: qs.stringify({ email: email })
	})
}
/**
 * 忘记密码，重置密码
 * @param query
 */
export function resetPwd(phone, pwd) {
	return request({
		url: '/api/user/forget/reset',
		method: 'post',
		data: qs.stringify({ phone: phone, password: pwd })
	})
}

/**
 * 刷新token
 * @param query
 */
export function refreshToken() {
	return request({
		url: '/api/refresh/token',
		method: 'get'
	})
}

/**
 * 获取用户基本信息和角色
 * @param query
 */
export function getInfo() {
	return request({
		url: '/api/a/user/info',
		method: 'get',
	})
}

/**
 * 获取用户的权限
 * @param query
 */
export function getPerms() {
	return request({
		url: '/api/a/user/permission',
		method: 'get'
	})
}

/**
 * 获取用户信息
 * @param query
 */
export function getUserInfo(token) {
	return request({
		url: '/api/a/getUserInfo',
		method: 'post',
		data: qs.stringify({ token: token })
	})
}

/**
 * 退出登录
 * @param query
 */
export function logout() {
	return request({
		url: '/api/a/logout',
		method: 'post'
	})
}

/**
 * 用户列表
 * @param query
 */
export function fetchList(query) {
	return request({
		url: '/api/user/list',
		method: 'post',
		data: query
	})
}

/**
 * 用户列表
 * @param query
 */
export function findAll(query) {
	return request({
		url: '/api/user/all',
		method: 'get',
		data: query
	})
}

/**
 * 保存用户
 * @param param
 */
export function save(param) {
	return request({
		url: '/api/user/save',
		method: 'post',
		data: param
	})
}

/**
 * 修改用户
 * @param param
 */
export function update(param) {
	return request({
		url: '/api/user/update',
		method: 'post',
		data: param
	})
}

/**
 * 修改用户个人密码
 * @param query
 */
export function editPassword (query) {
	return request({
		url: `/api/user/changepwd/${query.userId}`,
		method: 'post',
		data: query.param || {}
	})
}

/**
 * 冻结用户
 * @param param
 */
export function freeze(param) {
	return request({
		url: '/api/user/freeze/' + param,
		method: 'post'
	})
}

/**
 * 解冻用户
 * @param param
 */
export function unfreeze(param) {
	return request({
		url: '/api/user/unfreeze/' + param,
		method: 'post'
	})
}

/**
 * 删除用户
 * @param param
 */
export function remove(param) {
	return request({
		url: '/api/user/delete/' + param,
		method: 'post'
	})
}

/**
 * 获取单个用户信息
 * @param param
 */
export function get(param) {
	return request({
		url: '/api/user/view/' + param,
		method: 'get'
	})
}

/**
 * 初始化密码
 * @param ids
 */
export function initPassword(ids) {
	return request({
		url: '/api/user/initPassword',
		method: 'post',
		data: 'ids=' + ids
	})
}

/**
 * 修改头像
 *
 * @param ids
 */
export function updateAvatar(userId, avatar) {
	return request({
		url: '/api/user/avatar/' + userId,
		method: 'post',
		data: 'avatar=' + avatar
	})
}

/**
 * 上传头像
 *
 * @param ids
 */
export function uploadAvatar(data) {
	return request({
		url: '/api/upload/oss',
		method: 'post',
		headers: {
			'Content-Type': 'multipart/form-data'
		},
		data: data
	})
}

/**
 * 短信验证
 * @param query
 */
export function validCode(phone,code,type) {
	return request({
		url: '/api/valid/code',
		method: 'post',
		data: qs.stringify({phone,code,'type':type})
	})
}

/**
 * 发送短信
 * @param query
 */
export function sendSms(query) {
	return request({
		url: '/api/user/register/verify',
		method: 'post',
		data: qs.stringify(query)
	})
}

/**
 * 用户注册
 * @param query
 */
export function register(query) {
	return request({
		url: '/api/user/register',
		method: 'post',
		data: qs.stringify(query)
	})
}
